import React from "react";
import styles from "./ConfirmationModal.module.css";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  dataConfirm,
  text,
  ConfirmationTitle,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-info"></i>
          </div>
          <button className={styles.custommodalclose} onClick={() => onClose()}>
            ×
          </button>
        </div>

        <p className={styles.description}>{text}</p>
        <div className={styles.title}>
          {ConfirmationTitle ? ConfirmationTitle : "تأیید پرداخت؟"}
        </div>
        <div className={styles.actions}>
          <button
            className={styles.gonext}
            onClick={() => onConfirm(dataConfirm)}
          >
            بله حتما
          </button>
          <button className={styles.cancelButton} onClick={onClose}>
            نه ولش کن
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
